import { property } from 'underscore';

export default () => ({
  handler: 'absoluteUrl',
  data: property('externalUrl'),
});
